// Bản JS của vnc/standards design/components/report-problem.ts (patterns/help-menu.md, guides/07.2 mục 3, mục 5).
// Đặc tả VIMS: vims-docs/docs/modules/ho-tro/README.md. Đường dẫn chỉ mang ngữ cảnh kỹ thuật, không mang dữ liệu cá nhân (QC-05 U7).

/** Mã hệ VIMS trong danh mục hệ của MyVNC. */
export const SUPPORT_SYSTEM = 'VIMS'

const SYSTEM_RE = /^[A-Z0-9]{2,6}$/

/** Mã tra cứu dạng ngắn `<MÃ HỆ>-<8 ký tự đầu, in hoa>` từ requestId (guides/07.2 mục 3.2). */
export function lookupCode(system, requestId) {
  if (!SYSTEM_RE.test(system))
    throw new Error(`Mã hệ "${system}" sai dạng: 2–6 chữ in hoa hoặc số`)
  const head = String(requestId).replace(/[^0-9a-zA-Z]/g, '').slice(0, 8).toUpperCase()

  return `${system}-${head}`
}

/**
 * Đường dẫn trang tạo phiếu `/feedback/new` của MyVNC, điền sẵn ngữ cảnh. Chỉ sáu khoá MyVNC nhận (đặc tả feedback F3).
 * ctx: { baseUrl, system, kind?: 'BUG'|'SUPPORT'|'SUGGESTION', screen?: mẫu route, version?, code?, at?: Date }
 */
export function reportProblemUrl(ctx) {
  const q = new URLSearchParams({ system: ctx.system })
  if (ctx.kind)
    q.set('kind', ctx.kind)
  if (ctx.screen)
    q.set('screen', ctx.screen.slice(0, 120))
  if (ctx.version)
    q.set('version', ctx.version.slice(0, 40))
  if (ctx.code)
    q.set('code', ctx.code)
  q.set('at', (ctx.at ?? new Date()).toISOString())

  return `${ctx.baseUrl.replace(/\/+$/, '')}/feedback/new?${q}`
}

/** Trang "Phiếu hỗ trợ của tôi" trên MyVNC. */
export function myTicketsUrl(baseUrl) {
  return `${baseUrl.replace(/\/+$/, '')}/feedback`
}

/**
 * Mẫu route của màn đang mở từ đường dẫn bản ghi route của vue-router (`route.matched.at(-1).path`):
 * `/projects/:code()` → `/projects/[code]`, `:slug(.*)*` → `[...slug]`, `:id?` → `[[id]]`. Không bao giờ dùng đường dẫn thật.
 */
export function routePattern(recordPath) {
  if (!recordPath)
    return ''

  return recordPath
    .replace(/:(\w+)\(\.\*\)\*/g, '[...$1]')
    .replace(/:(\w+)(?:\([^)]*\))?\?/g, '[[$1]]')
    .replace(/:(\w+)(?:\([^)]*\))?/g, '[$1]')
}
